import { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import axios from "axios";
import { baseUrl } from "../utils/constants";
import localizationStrings from "../utils/localizations";
export function ChangeDestDialog({ currentLocation, leavingNo, houseId, refresh }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({
    lat_lng: `${currentLocation.latitude}, ${currentLocation.longitude}`,
  });
  const [tempLocation, setTempLocation] = useState({
    lat_lng: `${currentLocation.latitude}, ${currentLocation.longitude}`,
  });
  const [errors, setErrors] = useState({
    lat_lng: false,
  });

  const handleClickOpen = () => {
    setTempLocation({ ...location });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate input
    // const isValid =
    //   !isNaN(Number(value)) && (name === "latitude" ? Math.abs(Number(value)) <= 90 : Math.abs(Number(value)) <= 180);
    const [lat, lng] = value
      .split(",")
      .map((v) => v.trim())
      .map(parseFloat);
    const isValid = !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;

    setErrors({
      ...errors,
      [name]: !isValid,
    });

    setTempLocation({
      ...tempLocation,
      [name]: value,
    });
  };

  const handleSave = async () => {
    // Check if inputs are valid
    if (!errors.latitude && !errors.longitude) {
      setLoading(true);
      try {
        const obj = {
          latitude: tempLocation.lat_lng.split(",")[0].trim(),
          longitude: tempLocation.lat_lng.split(",")[1].trim(),
        };
        setLocation(obj);
        console.log("obj", obj);
        await axios.post(baseUrl + "changeDestinationOfTrip/" + leavingNo, {
          latitude: obj.latitude,
          longitude: obj.longitude,
          houseId: houseId,
        });
        setOpen(false);
        if (refresh) {
          refresh(true);
        }
        setLoading(false);
      } catch (error) {
        alert("Error updating location: " + (error.response?.data?.message || error.message));
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Button
          variant="contained"
          size="small"
          onClick={handleClickOpen}
          sx={{
            fontSize: 10,
            fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
            padding: "2px 4px",
          }}
        >
          <LocationOnIcon
            fontSize="small"
            sx={{
              fontSize: 12,
              marginRight: localizationStrings.getLanguage() === "ar" ? 0 : 1,
              marginLeft: localizationStrings.getLanguage() === "ar" ? 1 : 0,
            }}
          />
          {localizationStrings.Updatelocation}
        </Button>
      </Box>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ color: "black", fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook" }}
        >
          {localizationStrings.Updatelocation}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              mb: 2,
              color: "black",
              fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
            }}
          >
            {localizationStrings.Entlocation}
          </DialogContentText>
          <TextField
            label={localizationStrings.LatLng}
            variant="filled"
            value={tempLocation.lat_lng}
            name="lat_lng"
            fullWidth
            style={{
              fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
            }}
            onChange={handleChange}
            error={errors.lat_lng}
            helperText={errors.lat_lng ? localizationStrings.InvalidLatLng : ""}
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            sx={{ fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook" }}
            disabled={loading}
          >
            {localizationStrings.Cancel}
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            disabled={errors.lat_lng || loading}
            sx={{ fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook" }}
          >
            {localizationStrings.Save}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
